
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'

import {
SaafHeader,
SaafFooter,
} from '@/common/components/index'
import { mapState } from 'vuex'

import { fetchTool, httpUtil } from '@/common/index'
import api from './config/api'



export default {
data () {
return {
fileList:[]
}
},
components: {
SaafHeader,
SaafFooter,
XButton,
XInput,
Group,
},
computed: {
...mapState({
userInfo: state => state.user.userInfo,
}),
},
created(){

},
methods: {
async post(){
let params = {}
let res = await httpUtil.post(api.baseLookupTypeService_find,{params:JSON.stringify(params)},true);
if(res.status=="S"){
alert(JSON.stringify(res))
}else{
alert('失败')
}
}
},
watch:{
},
mounted(){

},
}




// WEBPACK FOOTER //
// ./src/page/demo/PostOld.vue